import { type DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import { hasSupportToBluetoothRemoteConnection } from '@cobliteam/api-lib/src/dashboard/device/utils';
import { useMemo } from 'react';
import useFeatureFlags from '../../useFeatureFlags';
import { useGetDevices } from './index';

// Same eligibility rule used by NoSignalBanner and UnavailableBanner: a device
// is a Cobli Conecta candidate when it is offline (NO_SIGNAL / UNAVAILABLE) and
// its hardware supports the Bluetooth remote-connection flow.
export const useCobliConectaCandidates = (): DeviceFragment[] => {
  const { useRemoteConnection } = useFeatureFlags();
  // Sem o flag, nada a sugerir: a lista de devices nem é buscada.
  const { data: devices } = useGetDevices({ options: { enabled: Boolean(useRemoteConnection) } });

  return useMemo(() => {
    if (!(useRemoteConnection && devices)) return [];
    return devices.filter(
      (d) =>
        hasSupportToBluetoothRemoteConnection(d.deviceModel ?? undefined) &&
        (d.generalStatus === DeviceGeneralStatus.NoSignal || d.generalStatus === DeviceGeneralStatus.Unavailable)
    );
  }, [useRemoteConnection, devices]);
};

export default useCobliConectaCandidates;
